<template>
    <div class="cadastrocliente ">
        <PageTitle icon="fas fa-user-check iconInterativoTitulo" main="CADASTRO CLIENTES HION"
            sub="Cadastro de Clientes e Empresas Nacionais e Internacionais" />

        <b-form class="ml-3 mr-3">
            <b-row>
                <b-col sm="12">
                    <b-form-group label="Natureza do Cadastro:" label-for="cliente-pessoa">
                        <b-form-select v-model="cliente.pessoa" id="cliente-pessoa"
                            :options="pessoa"  @change="resetPessoa()">
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            
            <b-row>
                <b-col sm="12">
                    <b-form-group label="Nome Completo:" label-for="cliente-nome" v-if="cliente.pessoa === 'fisica'">
                        <b-form-input id="cliente-nome" type="text"
                            v-model="cliente.nome_razao"
                            placeholder="Informe o nome completo do cliente..." />
                    </b-form-group>
                    <b-form-group label="Nome Completo:" label-for="cliente-nome" v-else-if="cliente.pessoa === 'estrangeiro'">
                        <b-form-input id="cliente-nome" type="text"
                            v-model="cliente.nome_razao"
                            placeholder="Informe o nome completo do cliente..." />
                    </b-form-group>
                    <b-form-group label="Razão Social Completa:" label-for="cliente-razao" v-else>
                        <b-form-input id="cliente-razao" type="text"
                            v-model="cliente.nome_razao"
                            placeholder="Informe a razão social completa da empresa..." />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row v-if="cliente.pessoa === 'estrangeiro'">
                <b-col sm="12">
                    <b-form-group label="RNE:" label-for="cliente-estrangeiro">
                        <b-form-input id="cliente-estrangeiro" type="text"
                            v-model="rneId"
                            placeholder="Informe o número do registro nacional de estrangeiro (RNE) ou documento similar..." />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row v-else>
                <b-col md="6" sm="12">
                    <b-form-group label="CPF:" label-for="cliente-cpf" v-if="cliente.pessoa === 'fisica'">
                        <b-input v-model="cpfId" :state="validaCPF" id="cliente-cpf"
                            placeholder="Informe o CPF do cliente..." />
                        <b-form-invalid-feedback :state="validaCPF">
                            CPF deve conter apenas 11 números
                        </b-form-invalid-feedback>
                        <b-form-valid-feedback :state="validaCPF">
                            Número de CPF Válido.
                        </b-form-valid-feedback>            
                    </b-form-group>
                    <b-form-group label="CNPJ:" label-for="cliente-cnpj" v-if="cliente.pessoa === 'juridica'">
                        <b-input v-model="cnpjId" :state="validaCNPJ" id="cliente-cnpj"
                            placeholder="Informe o CNPJ da empresa..." />
                        <b-form-invalid-feedback :state="validaCNPJ">
                            Informe CNPJ. Ex: xx.xxx.xxx/0001-xx ou xxxxxxxx0001xx
                        </b-form-invalid-feedback>
                        <b-form-valid-feedback :state="validaCNPJ">
                            Número de CNPJ Válido.
                        </b-form-valid-feedback>            
                    </b-form-group>
                    <b-form-group label="CNPJ:" label-for="cliente-internacional" v-if="cliente.pessoa === 'internacional'">
                         <b-form-input id="cliente-internacional" type="text"
                            v-model="cnpjId"
                            placeholder="Informe o número do cadastro de pessoa jurídica da empresa..." /> 
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="RG:" label-for="cliente-rg" v-if="cliente.pessoa === 'fisica'">
                         <b-form-input id="cliente-rg" type="text"
                            v-model="cliente.rg_fantasia"
                            placeholder="Informe o RG do cliente..." />
                    </b-form-group>
                    <b-form-group label="Nome Fantasia:" label-for="cliente-fantasia" v-else>
                        <b-form-input id="cliente-fantasia" type="text"
                            v-model="cliente.rg_fantasia"
                            placeholder="Informe o nome fantasia da empresa..." />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group label="Data de Nascimento:" label-for="cliente-nascimento" v-if="cliente.pessoa === 'fisica'">
                        <b-form-input id="cliente-nascimento" type="text"
                            v-model="dataId"
                            placeholder="Informe a data de nascimento do cliente..." 
                            v-on:keyup="validarData(dataId)" />
                    </b-form-group>
                    <b-form-group label="Data de Nascimento:" label-for="cliente-nascimento" v-else-if="cliente.pessoa === 'estrangeiro'">
                        <b-form-input id="cliente-nascimento" type="text"
                            v-model="dataId"
                            placeholder="Informe a data de nascimento do cliente..." 
                            v-on:keyup="validarData(dataId)" />
                    </b-form-group>
                    <b-form-group label="Data de Fundação:" label-for="cliente-fundacao" v-else>
                        <b-form-input id="cliente-nascimento" type="text"
                            v-model="dataId"
                            placeholder="Informe a data de fundação da empresa..." 
                            v-on:keyup="validarData(dataId)" />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="CEP:" label-for="cliente-cep">
                        <b-form-input id="cliente-cep" type="text"
                            v-model="cepId"
                            placeholder="Informe o CEP do cliente..." 
                            v-on:keyup="validarCEP(cepId)" />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group label="Endereço:" label-for="cliente-endereco">
                        <b-form-input id="cliente-endereco" type="text"
                            v-model="cliente.endereco" v-if="cliente.pessoa === 'fisica'"
                            placeholder="Informe o endereço do cliente..." />
                        <b-form-input id="cliente-endereco" type="text"
                            v-model="cliente.endereco" v-else-if="cliente.pessoa === 'estrangeiro'"
                            placeholder="Informe o endereço do cliente..." />
                        <b-form-input id="cliente-endereco" type="text"
                            v-model="cliente.endereco" v-else
                            placeholder="Informe o endereço da empresa..." />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="Número:" label-for="cliente-numero">
                        <b-form-input id="cliente-numero" type="text"
                            v-model="cliente.numero" v-if="cliente.pessoa === 'fisica'"
                            placeholder="Informe o número da residência do cliente" />
                         <b-form-input id="cliente-numero" type="text"
                            v-model="cliente.numero" v-else-if="cliente.pessoa === 'estrangeiro'"
                            placeholder="Informe o número da residência do cliente" />
                        <b-form-input id="cliente-numero" type="text"
                            v-model="cliente.numero" v-else
                            placeholder="Informe o número da sede da empresa" />
                    </b-form-group>
                </b-col>
                
            </b-row>
            
            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group label="Complemento:" label-for="cliente-complemento">
                        <b-form-input id="cliente-complemento" type="text"
                            v-model="cliente.complemento" v-if="cliente.pessoa === 'fisica'"
                            placeholder="Ex: Torre B Apto 31, Casa Fundos etc..." />
                        <b-form-input id="cliente-complemento" type="text"
                            v-model="cliente.complemento" v-else-if="cliente.pessoa === 'estrangeiro'"
                            placeholder="Ex: Torre B Apto 31, Casa Fundos etc..." />
                        <b-form-input id="empresa-complemento" type="text"
                            v-model="cliente.complemento" v-else
                            placeholder="Ex: Conjunto B, Galpão 3, Sala 5 etc..." />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="Bairro:" label-for="cliente-bairro">
                        <b-form-input id="cliente-bairro" type="text"
                            v-model="cliente.bairro" v-if="cliente.pessoa === 'fisica'"
                            placeholder="Informe o bairro do cliente..." />
                        <b-form-input id="cliente-bairro" type="text"
                            v-model="cliente.bairro" v-else-if="cliente.pessoa === 'estrangeiro'"
                            placeholder="Informe o bairro do cliente..." />
                        <b-form-input id="cliente-bairro" type="text"
                            v-model="cliente.bairro" v-else
                            placeholder="Informe o bairro da sede da empresa..." />
                    </b-form-group>
                </b-col>
            </b-row>
            
            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group label="Cidade:" label-for="cliente-cidade">
                        <b-form-input id="cliente-cidade" type="text"
                            v-model="cliente.cidade" v-if="cliente.pessoa === 'fisica'"
                            placeholder="Informe a cidade do cliente..." />
                        <b-form-input id="cliente-cidade" type="text"
                            v-model="cliente.cidade" v-else-if="cliente.pessoa === 'estrangeiro'"
                            placeholder="Informe a cidade do cliente..." />
                        <b-form-input id="cliente-cidade" type="text"
                            v-model="cliente.cidade" v-else
                            placeholder="Informe a cidade da sede da empresa..." />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="País:" label-for="cliente-estado" v-if="cliente.pessoa === 'estrangeiro'">
                        <b-form-input id="cliente-estado" type="text"
                            v-model="cliente.estado" />
                    </b-form-group>
                    <b-form-group label="País:" label-for="cliente-estado" v-else-if="cliente.pessoa === 'internacional'">
                        <b-form-input id="cliente-estado" type="text"
                            v-model="cliente.estado" />
                    </b-form-group>
                    <b-form-group label="Estado:" label-for="cliente-estado" v-else>
                        <b-form-select v-model="cliente.estado" id="cliente-estado"
                            :options="estadosBrasil">
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            
            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group label="Telefone:" label-for="cliente-telefone">
                        <b-form-input id="cliente-telefone" type="text"
                            v-model="cliente.telefone"
                            placeholder="Telefone do cliente... Ex: 1141234567"
                            v-on:keyup="validarTelefone(cliente.telefone)" />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="Celular:" label-for="cliente-celular">
                        <b-form-input id="cliente-celular" type="text"
                            v-model="cliente.celular"
                            placeholder="Celular do cliente... Ex: 11912345678"
                            v-on:keyup="validarCelular(cliente.celular)" />
                    </b-form-group>
                </b-col> 
            </b-row>

            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group label="E-mail:" label-for="cliente-email">     
                        <b-input v-model="emailId" :state="validaEMAIL" id="cliente-email"
                            placeholder="Informe o E-mail para acesso a plataforma..." />
                        <b-form-invalid-feedback :state="validaEMAIL">
                            Insira um E-mail válido. ex@gmail.com
                        </b-form-invalid-feedback>
                        <b-form-valid-feedback :state="validaEMAIL">
                            E-mail Válido
                        </b-form-valid-feedback>
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="Senha:" label-for="cliente-hionacredita">
                        <b-input type="password" v-model="acreditaId" :state="validaAcredita" id="cliente-hionacredita"
                            placeholder="Informe a senha ..." />
                        <b-form-invalid-feedback :state="validaAcredita">
                            Insira qualquer combinação entre 8 e 12 dígitos
                        </b-form-invalid-feedback>
                        <b-form-valid-feedback :state="validaAcredita">
                            Senha Válida
                        </b-form-valid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="12">
                    <b-form-group label="Forma de Pagamento:" label-for="cliente-forma-pag">
                        <b-form-select v-model="formasPagmento" id="cliente-forma-pag"
                            :options="formasPag"
                            @change="resetPagamento()">
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row v-if="formasPagmento === 'cartao'">
                <b-col md="6" sm="12">
                    <b-form-group label="Cartão de Crédito:" label-for="cliente-cartao">
                        <b-form-input id="cliente-cartao" type="text"
                            v-model="cliente.cartao"
                            placeholder="Informe o número da cartão a creditar..." 
                            @blur.native="validarCartao(cliente.cartao)"/>
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="Bandeira do Cartão:" label-for="cliente-bandeira">
                        <b-form-select v-model="bandeiraCartao" id="cliente-bandeira"
                            :options="bandeirasCartao">
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row v-if="formasPagmento === 'cartao'">
                <b-col md="6" sm="12">
                    <b-form-group label="Nome do Titular:" label-for="cliente-nome-cartao">
                        <b-form-input id="cliente-nome-cartao" type="text"
                            v-model="cliente.nome_cartao"
                            placeholder="Nome do titular impresso no cartão..." />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="Validade:" label-for="cliente-valid-mes">
                        <b-form-input id="cliente-valid-mes" type="text"
                            v-model="cliente.valid_mes"
                            placeholder="Validade do cartão de crédito. MM/AA"
                            v-on:keyup="validarValidade(cliente.valid_mes)" />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row v-if="formasPagmento === 'cartao'">
                <b-col sm="12">
                    <b-form-group label="CSC:" label-for="cliente-csc">
                        <b-form-input id="cliente-csc" type="text"
                            v-model="cliente.csc"
                            placeholder="Código CSC do cartão de crédito..." />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row v-if="formasPagmento === 'debito'">
                <b-col md="6" sm="12">
                    <b-form-group label="Banco:" label-for="cliente-banco">
                        <b-form-input id="cliente-banco" type="text"
                            v-model="cliente.banco"
                            placeholder="Informe o nome do Banco..." />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="Agência:" label-for="cliente-agencia">
                        <b-form-input id="cliente-agencia" type="text"
                            v-model="cliente.agencia"
                            placeholder="Informe a agência com o dígito..." />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row v-if="formasPagmento === 'debito'">
                <b-col sm="12">
                    <b-form-group label="Conta Corrente:" label-for="cliente-cc">
                        <b-form-input id="cliente-cc" type="text"
                            v-model="cliente.cc"
                            placeholder="Número da conta corrente com dígito..." />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="12">
                    <b-form-group label="Status:" label-for="cliente-status">
                        <b-form-select v-model="statusSelecionado" id="cliente-status"
                            :options="statusCliente">
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="12">
                    <b-form-group label="Anotações Gerais:" label-for="cliente-anotacoes">
                        <b-form-textarea id="cliente-anotacoes" type="text"
                            v-model="cliente.anotacoes"
                            placeholder="Efetue anotações gerais e pertinentes ao referente cadastro..."
                            rows="5"
                            max-rows="10" />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col xs="12">
                    <b-button variant="primary" v-if="cliente.pessoa === 'fisica'"
                        @click="save" >Cadastrar Cliente</b-button>
                    <b-button variant="primary" v-else-if="cliente.pessoa === 'estrangeiro'"
                        @click="save" >Cadastrar Cliente</b-button>
                    <b-button variant="primary" v-else
                        @click="save" >Cadastrar Empresa</b-button>
                    <b-button class="ml-2" @click="reset">Cancelar</b-button>
                </b-col>
            </b-row>

        </b-form>

        <hr class="ml-2 mr-2">
        
    </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto'
import PageTitle from '../PageTitle'
import { baseApiUrl, userKey, showError } from '../../../global'
import axios from 'axios'

export default {
    name: 'CadastroCliente',
    components: { PageTitle } ,
    data: function() {
        return {
            cliente: { pessoa: 'fisica', estado: null },
            statusSelecionado: null,
            formasPagmento: null,
            bandeiraCartao: null,
            cpfId: '',
            cnpjId: '',
            rneId: '',
            dataId: '',
            cepId: '',
            validaCEP: false,
            validaCelular: false,
            validaTelefone: false,
            validaValidade: false,
            emailId: '',
            acreditaId: '',
            validaData: false,
            estadosBrasil: [
                { value: null, text: 'Selecione o Estado' },
                { value: 'AC', text: 'Acre (AC)' },
                { value: 'AL', text: 'Alagoas (AL)' },
                { value: 'AP', text: 'Amapá (AP)' },
                { value: 'AM', text: 'Amazonas (AM)' },
                { value: 'BA', text: 'Bahia (BA)' },
                { value: 'CE', text: 'Ceará (CE)' },
                { value: 'DF', text: 'Distrito Federal (DF)' },
                { value: 'ES', text: 'Espírito Santo (ES)' },
                { value: 'GO', text: 'Goiás (GO)' },
                { value: 'MA', text: 'Maranhão (MA)' },
                { value: 'MT', text: 'Mato Grosso (MT)' },
                { value: 'MS', text: 'Mato Grosso do Sul (MS)' },
                { value: 'MG', text: 'Minas Gerais (MG)' },
                { value: 'PA', text: 'Pará (PA)' },
                { value: 'PB', text: 'Paraíba (PB)' },
                { value: 'PR', text: 'Paraná (PR)' },
                { value: 'PE', text: 'Pernambuco (PE)' },
                { value: 'PI', text: 'Piauí (PI)' },
                { value: 'RJ', text: 'Rio de Janeiro (RJ)' },
                { value: 'RN', text: 'Rio Grande do Norte (RN)' },
                { value: 'RS', text: 'Rio Grande do Sul (RS)' },
                { value: 'RO', text: 'Rondônia (RO)' },
                { value: 'RR', text: 'Roraima (RR)' },
                { value: 'SC', text: 'Santa Catarina (SC)' },
                { value: 'SP', text: 'São Paulo (SP)' },
                { value: 'SE', text: 'Sergipe (SE)' },
                { value: 'TO', text: 'Tocantins (TO)' }
            ],
            statusCliente: [
                { value: null, text: 'Status inicial do cliente' },
                { value: 'ativo', text: 'Ativo' },
                { value: 'inativo', text: 'Inativo' },
                { value: 'atraso', text: 'Atraso' },
                { value: 'suspenso', text: 'Suspenso' },
                { value: 'desligado', text: 'Desligado' },
            ],
            pessoa: [
                { value: 'fisica', text: 'Pessoa Física' },
                { value: 'estrangeiro', text: 'Pessoa Física Estrangeira' },
                { value: 'juridica', text: 'Pessoa Jurídica' },
                { value: 'internacional', text: 'Pessoa Jurídica Estrangeira' },
            ],
            formasPag: [
                { value: null, text: 'Selecione a forma de pagamento...' },
                { value: 'cartao', text: 'Cartão de Crédito' },
                { value: 'debito', text: 'Débito Automático' },
            ],
            bandeirasCartao: [
                { value: null, text: 'Selecione a bandeira do cartão...' },
                { value: 'master', text: 'Mastercard' },
                { value: 'visa', text: 'Visa' },
            ]
        }
    },
    computed: {
        validaCPF() { return this.validarCPF(this.cpfId) },
        validaCNPJ() { return this.validarCNPJ(this.cnpjId) },
        validaEMAIL() { return this.validarEmail(this.emailId) },
        validaAcredita() { return this.validarHionAcredita(this.acreditaId) }
    },
    methods: {
        resetPessoa() {
            this.cliente.nome_razao = '';
            this.cliente.cpf_cnpj = '';
            this.cliente.rg_fantasia = '';
            this.cliente.cep = '';
            this.cliente.nascimento = '';
            this.cliente.endereco = '';
            this.cliente.numero = '';
            this.cliente.complemento = '';
            this.cliente.bairro = '';
            this.cliente.cidade = '';
            this.cliente.estado = '';
            this.cliente.celular = '';
            this.cliente.telefone = '';
            this.statusSelecionado = null;
            this.formasPagmento = null;
            this.bandeiraCartao = null;
            this.cpfId = '';
            this.cnpjId = '';
            this.rneId = '';
            this.dataId = '';
            this.validaCPF = false;
            this.validaCNPJ = false;
            this.validaData = false;
            this.validaCelular = false;
            this.validaTelefone = false;
            this.validaValidade = false;
            this.cepId = '';
            this.validaCEP = false;
            this.emailId = '';
            this.acreditaId = '';
            this.statusSelecionado = null;
        },
        resetPagamento() {
            this.cliente.cartao = '';
            this.cliente.bandeira= '';
            this.cliente.nome_cartao = '';
            this.cliente.valid_mes = '';
            this.cliente.valid_ano = '';
            this.cliente.csc === '';
            this.cliente.banco = '';
            this.cliente.agencia = '';
            this.cliente.cc = '';
            this.statusSelecionado = null;
        },        
        save(evt) {
            evt.preventDefault()          //previne comportamento padrao ao clicar no botao enviar

            //Realiza uma série de validações antes de submeter o formulário para o servidor Hion
            ////////////////////////////////////////////////////////////////////////////////////////
            if((this.cliente.nome_razao === '') || (this.cliente.nome_razao === undefined))  {
                if(this.cliente.pessoa === 'fisica' || this.cliente.pessoa === 'estrangeiro') {
                    this.$toasted.global.defaultInfo({ msg : 'Por favor insira o nome do cliente!' });
                    VueScrollTo.scrollTo('#cliente-nome');
                    document.getElementById("cliente-nome").focus()
                } else {
                    this.$toasted.global.defaultInfo({ msg : 'Por favor insira a razão social da empresa!' })
                    VueScrollTo.scrollTo('#cliente-razao');
                    document.getElementById("cliente-razao").focus()
                }
               return
            }
            if (this.cliente.pessoa === 'fisica') {
                if(this.cpfId === '') {
                    this.$toasted.global.defaultInfo({ msg : 'Por favor insira o CPF do cliente!' })
                    VueScrollTo.scrollTo('#cliente-cpf');
                    document.getElementById("cliente-cpf").focus()
                    return
                }
                if(!this.validaCPF) {
                    this.$toasted.global.defaultInfo({ msg : 'Por favor insira um CPF válido!' })
                    VueScrollTo.scrollTo('#cliente-cpf');
                    document.getElementById("cliente-cpf").focus()
                    return
                }
                let SoNumero = this.cpfId.replace(/\D/g, '');
                this.cliente.cpf_cnpj = SoNumero    //se CPF for validado , carrega CPF no objeto de saida
            }
 
            if (this.cliente.pessoa === 'juridica' || this.cliente.pessoa === 'internacional') {    //caso pessoa juridica
                if(this.cnpjId === '') {
                    this.$toasted.global.defaultInfo({ msg : 'Por favor insira o CNPJ da empresa!' })
                    VueScrollTo.scrollTo('#cliente-internacional');VueScrollTo.scrollTo('#cliente-cnpj');
                    document.getElementById("cliente-internacional").focus();document.getElementById("cliente-cnpj").focus()
                    return
                }
                if(this.cliente.pessoa === 'juridica') {
                    if(!this.validaCNPJ) {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira um CNPJ válido!' })
                        VueScrollTo.scrollTo('#cliente-cnpj');
                        document.getElementById("cliente-cnpj").focus()
                        return
                    }
                }
                let SoNumero2 = this.cnpjId.replace(/\D/g, '');
                this.cliente.cpf_cnpj = SoNumero2    //se CNPJ for validado , carrega CNPJ no objeto de saida
            }

            if (this.cliente.pessoa === 'estrangeiro') {
                if(this.rneId === '') {
                    this.$toasted.global.defaultInfo({ msg : 'Por favor insira o RNE do cliente!' })
                    VueScrollTo.scrollTo('#cliente-estrangeiro');
                    document.getElementById("cliente-estrangeiro").focus()
                    return
                }
                 let SoNumero3 = this.rneId.replace(/\D/g, '');
                this.cliente.cpf_cnpj = SoNumero3    //se CPF for validado , carrega CPF no objeto de saida
            }

            if (this.cliente.pessoa === 'fisica') {
                if((this.cliente.rg_fantasia === '') || (this.cliente.rg_fantasia === undefined))  {
                    this.$toasted.global.defaultInfo({ msg : 'Por favor insira o RG do cliente!' })
                    VueScrollTo.scrollTo('#cliente-rg');
                    document.getElementById("cliente-rg").focus()
                    return
                }
                if((this.cliente.rg_fantasia.length <= 6) || (this.cliente.rg_fantasia.length >= 13))  {
                    this.$toasted.global.defaultInfo({ msg : 'Por favor insira um RG válido!' })
                    VueScrollTo.scrollTo('#cliente-rg');
                    document.getElementById("cliente-rg").focus()
                    return
                }
            } 
            if (this.cliente.pessoa === 'juridica' || this.cliente.pessoa === 'internacional') {    //caso pessoa juridica
                if((this.cliente.rg_fantasia === '') || (this.cliente.rg_fantasia === undefined))  {
                    this.$toasted.global.defaultInfo({ msg : 'Por favor informe o nome fantasia da empresa!' })
                    VueScrollTo.scrollTo('#cliente-fantasia');
                    document.getElementById("cliente-fantasia").focus()
                    return
                }
            }

            if((this.dataId === '') || (this.dataId === undefined))  {
               if (this.cliente.pessoa === 'fisica' || this.cliente.pessoa === 'estrangeiro') this.$toasted.global.defaultInfo({ msg : 'Por favor informe a data de nascimento do cliente!' })
                else this.$toasted.global.defaultInfo({ msg : 'Por favor informe a data de fundação da empresa!' })

                VueScrollTo.scrollTo('#cliente-nascimento');
                document.getElementById("cliente-nascimento").focus()
                return
            }
            if(!this.validaData) {
                if (this.cliente.pessoa === 'fisica' || this.cliente.pessoa === 'estrangeiro') this.$toasted.global.defaultInfo({ msg : 'Por favor informe uma data de nascimento válida!' })
                    else this.$toasted.global.defaultInfo({ msg : 'Por favor informe uma data de fundação válida!' })
                
                VueScrollTo.scrollTo('#cliente-nascimento');
                document.getElementById("cliente-nascimento").focus()
                return
            }

            this.cliente.nascimento = this.converteData(this.dataId)//se Nascimento for validado , carrega Data no objeto de saida

            if(this.cepId === '') {
                if (this.cliente.pessoa === 'fisica' || this.cliente.pessoa === 'estrangeiro') this.$toasted.global.defaultInfo({ msg : 'Por favor informe o CEP do cliente!' })
                    else this.$toasted.global.defaultInfo({ msg : 'Por favor informe o CEP da empresa!' })
                
                VueScrollTo.scrollTo('#cliente-cep');
                document.getElementById("cliente-cep").focus()
                return
            }
            if(!this.validaCEP) {
                this.$toasted.global.defaultInfo({ msg : 'Por favor informe um CEP válido!' })
                VueScrollTo.scrollTo('#cliente-cep');
                document.getElementById("cliente-cep").focus()
                return
            }

            this.cliente.cep = this.cepId       //se CEP for validado , carrega Data no objeto de saida 

            if((this.cliente.endereco === '') || (this.cliente.endereco === undefined))  {
               if (this.cliente.pessoa === 'fisica' || this.cliente.pessoa === 'estrangeiro') this.$toasted.global.defaultInfo({ msg : 'Por favor informe o endereço do cliente!' })
                else this.$toasted.global.defaultInfo({ msg : 'Por favor informe o endereço da sede da empresa!' })
                
                VueScrollTo.scrollTo('#cliente-endereco');
                document.getElementById("cliente-endereco").focus()
               return
            }

            if((this.cliente.numero === '') || (this.cliente.numero === undefined))  {
                if (this.cliente.pessoa === 'fisica' || this.cliente.pessoa === 'estrangeiro') this.$toasted.global.defaultInfo({ msg : 'Por favor insira o número da residência do cliente!' })
                    else this.$toasted.global.defaultInfo({ msg : 'Por favor insira o número da sede da empresa!' })
                
                VueScrollTo.scrollTo('#cliente-numero');
                document.getElementById("cliente-numero").focus()
                return
            }

            if((this.cliente.bairro === '') || (this.cliente.bairro === undefined))  {
                if (this.cliente.pessoa === 'fisica' || this.cliente.pessoa === 'estrangeiro') this.$toasted.global.defaultInfo({ msg : 'Por favor informe o bairro do cliente!' })
                    else this.$toasted.global.defaultInfo({ msg : 'Por favor informe o bairro da sede da empresa!' })
                
                VueScrollTo.scrollTo('#cliente-bairro');
                document.getElementById("cliente-bairro").focus()
                return
            }

            if((this.cliente.cidade === '') || (this.cliente.cidade === undefined))  {
                if (this.cliente.pessoa === 'fisica' || this.cliente.pessoa === 'estrangeiro') this.$toasted.global.defaultInfo({ msg : 'Por favor informe a cidade do cliente!' })
                    else this.$toasted.global.defaultInfo({ msg : 'Por favor informe a cidade da sede da empresa!' })
                
                VueScrollTo.scrollTo('#cliente-cidade');
                document.getElementById("cliente-cidade").focus()
                return
            }

            if (this.cliente.pessoa === 'estrangeiro' || this.cliente.pessoa === 'internacional') {
                if((this.cliente.estado === null) || (this.cliente.estado === '') || (this.cliente.estado === undefined))  {
                    if (this.cliente.pessoa === 'estrangeiro') this.$toasted.global.defaultInfo({ msg : 'Por favor informe o País do cliente!' })
                        else this.$toasted.global.defaultInfo({ msg : 'Por favor informe o País da empresa' })
                    
                    VueScrollTo.scrollTo('#cliente-estado');
                    document.getElementById("cliente-estado").focus()
                    return
                }
            } else {
                if(this.cliente.estado === null) {
                    this.$toasted.global.defaultInfo({ msg : 'Por favor informe o estado!' })
                    VueScrollTo.scrollTo('#cliente-estado');
                    document.getElementById("cliente-estado").focus()
                    return
                }
            }

    
            if(!((this.cliente.telefone === '') || (this.cliente.telefone === undefined))) {
                if(!this.validaTelefone) {
                    this.$toasted.global.defaultInfo({ msg : 'Por favor informe um número de telefone válido!' })
                    VueScrollTo.scrollTo('#cliente-telefone');
                    document.getElementById("cliente-telefone").focus()
                    return
                }
            }
    
            if((this.cliente.celular === '') || (this.cliente.celular === undefined)) {
               this.$toasted.global.defaultInfo({ msg : 'Por favor informe o celular do cliente!' })
                VueScrollTo.scrollTo('#cliente-celular');
                document.getElementById("cliente-celular").focus()
               return
            }
            if(!this.validaCelular) {
                this.$toasted.global.defaultInfo({ msg : 'Por favor informe um celular válido!' })
                VueScrollTo.scrollTo('#cliente-celular');
                document.getElementById("cliente-celular").focus()
                return
            }

            if(this.emailId === '') {
               this.$toasted.global.defaultInfo({ msg : 'Por favor insira o E-mail para acesso a plataforma!' })
               VueScrollTo.scrollTo('#cliente-email');
                document.getElementById("cliente-email").focus()
               return
            }
            if(!this.validaEMAIL) {
                this.$toasted.global.defaultInfo({ msg : 'Por favor informe um e-mail válido!' })
                VueScrollTo.scrollTo('#cliente-email');
                document.getElementById("cliente-email").focus()
                return
            }

            this.cliente.email = this.emailId;
          
            this.cliente.admin = true;
            this.cliente.nivel = 1;

            if (this.statusSelecionado === null) {
                this.$toasted.global.defaultInfo({ msg : 'Por favor informe a status que o cliente se enquadra!' })
                VueScrollTo.scrollTo('#cliente-status');
                document.getElementById("cliente-status").focus()
                return
            } else {
                this.cliente.status = this.statusSelecionado;
            }

            if (this.statusSelecionado == 'ativo') {
                if (this.cliente.pessoa === 'fisica' || this.cliente.pessoa === 'estrangeiro') this.cliente.privilegio = 0b00000111;
                    else this.cliente.privilegio = 0b00001111;  //adiciona privilegio de empresa
            } else {
                if (this.cliente.pessoa === 'fisica' || this.cliente.pessoa === 'estrangeiro') this.cliente.privilegio = 0b00000110;
                    else this.cliente.privilegio = 0b00001110;  //adiciona privilegio de empresa
            }

            if(!(this.formasPagmento === null)) {   //se foi selecioonado alguma forma de pagamento
                
                this.cliente.forma_pag = this.formasPagmento;   //carrega objeto de saida com o valor selecionado

                switch (this.formasPagmento) {
                    case 'cartao':
                        if((this.cliente.cartao === '') || (this.cliente.cartao === undefined)) {
                            this.$toasted.global.defaultInfo({ msg : 'Por favor informe número do cartão de crédito!' })
                            VueScrollTo.scrollTo('#cliente-cartao');
                            document.getElementById("cliente-cartao").focus()
                            return
                        }
                        if((this.cliente.bandeira === '') || (this.cliente.bandeira === undefined)) {
                            this.$toasted.global.defaultInfo({ msg : 'Por favor informe a bandeira do cartão de crédito!' })
                            VueScrollTo.scrollTo('#cliente-bandeira');
                            document.getElementById("cliente-bandeira").focus()
                            return
                        }
                        if((this.cliente.nome_cartao === '') || (this.cliente.nome_cartao === undefined)) {
                            this.$toasted.global.defaultInfo({ msg : 'Por favor insira o nome do titular do cartão!' })
                            VueScrollTo.scrollTo('#cliente-nome-cartao');
                            document.getElementById("cliente-nome-cartao").focus()
                            return
                        }

                        if((this.cliente.valid_mes === '') || (this.cliente.valid_mes === undefined))  {
                            this.$toasted.global.defaultInfo({ msg : 'Por favor insira a validade do cartão de crédito!' })
                            VueScrollTo.scrollTo('#cliente-valid-mes');
                            document.getElementById("cliente-valid-mes").focus()
                            return
                        }
                        if(this.validaValidade === false) {
                            this.$toasted.global.defaultInfo({ msg : 'Validade do cartão de crédito inválida!' })
                            VueScrollTo.scrollTo('#cliente-valid-mes');
                            document.getElementById("cliente-valid-mes").focus()
                            return
                        }


                        if((this.cliente.csc === '') || (this.cliente.csc === undefined)) {
                            this.$toasted.global.defaultInfo({ msg : 'Por favor insira o código csc do cartão!' })
                            VueScrollTo.scrollTo('#cliente-csc');
                            document.getElementById("cliente-csc").focus()
                            return
                        } else {
                            if(!isNaN(parseFloat(this.cliente.csc)) && isFinite(this.cliente.csc)) {       //Obriga entrada ser apenas de números
                                if ((this.cliente.csc.length == 3) && (this.cliente.csc >= 1) && (this.cliente.csc <= 999)) {
                                    //Sucesso - nao realiza nada, mais fica aqui espaço para aprimeoramento futuro
                                } else {
                                    this.$toasted.global.defaultInfo({ msg : 'Código CSC inválido!' })
                                    VueScrollTo.scrollTo('#cliente-csc');
                                    document.getElementById("cliente-csc").focus()
                                    return
                                }
                            } else {
                                this.$toasted.global.defaultInfo({ msg : 'Código CSC inválido!' })
                                VueScrollTo.scrollTo('#cliente-csc');
                                document.getElementById("cliente-csc").focus()
                                return
                            }
                        }
                        break;
                    case 'debito':
                        if((this.cliente.banco === '') || (this.cliente.banco === undefined)) {
                            this.$toasted.global.defaultInfo({ msg : 'Por favor informe o banco para débito automático!' })
                            VueScrollTo.scrollTo('#cliente-banco');
                            document.getElementById("cliente-banco").focus()
                            return
                        }
                        if((this.cliente.agencia === '') || (this.cliente.agencia === undefined)) {
                            this.$toasted.global.defaultInfo({ msg : 'Por favor informe a agência do banco para débito automático!' })
                            VueScrollTo.scrollTo('#cliente-agencia');
                            document.getElementById("cliente-agencia").focus()
                            return
                        }
                        if((this.cliente.cc === '') || (this.cliente.cc === undefined)) {
                            this.$toasted.global.defaultInfo({ msg : 'Por favor informe a conta corrente débito automático!' })
                            VueScrollTo.scrollTo('#cliente-cc');
                            document.getElementById("cliente-cc").focus()
                            return
                        }
                        break;
                }
            }

            //verifica se campos INTEGER estão vazios, e caso sim, iguala a zero e transforma string em numero
            if((this.cliente.valid_mes === '') || (this.cliente.valid_mes === undefined))  this.cliente.valid_mes = 0;
            if((this.cliente.valid_ano === '') || (this.cliente.valid_ano === undefined))  this.cliente.valid_ano = 0;
            if((this.cliente.csc === '') || (this.cliente.csc === undefined))  this.cliente.csc = 0;

            if(this.acreditaId === '') {
                this.cliente.hionacredita = '';
            } else {
                if (!this.validaAcredita) {
                    this.$toasted.global.defaultInfo({ msg : "Senha inválida - Escolha uma combinação entre 8 e 12 caracteres!" });
                    VueScrollTo.scrollTo('#cliente-hionacredita');
                    document.getElementById("cliente-hionacredita").focus()
                    return
                } else {
                    this.cliente.hionacredita = this.acreditaId;
                }
            }

            ////////////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////////

            //Se passou por todas as validações, submete formulário para servidor Hion

            //seta usuario ficticio para testes no DEV
           /* const payload = {
                atual: {
                    id: 1,
                    nome_razao: "Bruno",
                    cpf_cnpj: "22813828399",
                    email: "bruno.dias@hiontecnologia.com.br",
                    hion: true,
                    admin: true,
                    nivel: 0,
                    prt: 0xff,
                },
                token: "c-137"
            }
            //this.$store.commit('setUser', payload)
            localStorage.setItem(userKey, JSON.stringify(payload))
            */

            //Adquiri o usuario atual da requisição
            const json = localStorage.getItem(userKey);
            const userData = JSON.parse(json);

            //Monta pacote para envio ao servidor
            const pacote = {
                usuario: userData,
                cliente: this.cliente
            }

            axios.post(`${baseApiUrl}/cadastroCliente`, pacote)
                .then((res) => {
                    if (res.status == 200) {
                        this.$toasted.global.defaultSuccess({ msg : 'Cliente Hion cadastrado com sucesso!' })
                        if(this.cliente.hionacredita === '') this.$toasted.global.defaultInfo({ msg : 'Cliente cadastrado conforme padrão!' })
                        //this.reset()            //Ao concluir o cadastro reseta os valores de todos os campos
                    }
                })
                .catch(showError)
        },
        reset() {
            this.cliente = {};
            this.cliente = { pessoa: 'fisica', estado: null },
            this.statusSelecionado = null;
            this.formasPagmento = null;
            this.bandeiraCartao = null;
            this.cpfId = '';
            this.cnpjId = '';
            this.rneId = '';
            this.dataId = '';
            this.validaCPF = false;
            this.validaCNPJ = false;
            this.validaData = false;
            this.validaCelular = false;
            this.validaTelefone = false;
            this.validaValidade = false;
            this.cepId = '';
            this.validaCEP = false;
            this.emailId = '';
            this.acreditaId = '';
        },
        validarCPF(inputCPF){
            let soma = 0;
            let resto;

            if(inputCPF == '00000000000') return false;
            for(let i=1; i<=9; i++) soma = soma + parseInt(inputCPF.substring(i-1, i)) * (11 - i);
            resto = (soma * 10) % 11;

            if((resto == 10) || (resto == 11)) resto = 0;
            if(resto != parseInt(inputCPF.substring(9, 10))) return false;

            soma = 0;
            for(let i = 1; i <= 10; i++) soma = soma + parseInt(inputCPF.substring(i-1, i))*(12-i);
            resto = (soma * 10) % 11;

            if((resto == 10) || (resto == 11)) resto = 0;
            if(resto != parseInt(inputCPF.substring(10, 11))) return false;
            if(inputCPF.length == 11) return true;
            return false;
        },
        validarCNPJ(cnpj){
            cnpj = cnpj.replace(/[^\d]+/g,'');
        
            if(cnpj == '') return false;
            
            if (cnpj.length != 14)
                return false;
        
            // Elimina CNPJs invalidos conhecidos
            if (cnpj == "00000000000000" || 
                cnpj == "11111111111111" || 
                cnpj == "22222222222222" || 
                cnpj == "33333333333333" || 
                cnpj == "44444444444444" || 
                cnpj == "55555555555555" || 
                cnpj == "66666666666666" || 
                cnpj == "77777777777777" || 
                cnpj == "88888888888888" || 
                cnpj == "99999999999999")
                return false;
                
            // Valida DVs
            let tamanho = cnpj.length - 2
            let numeros = cnpj.substring(0,tamanho);
            let digitos = cnpj.substring(tamanho);
            let soma = 0;
            let pos = tamanho - 7;

            for (let i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2) pos = 9;
            }

            let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            
            if (resultado != digitos.charAt(0)) return false;
                
            tamanho = tamanho + 1;
            numeros = cnpj.substring(0,tamanho);
            soma = 0;
            pos = tamanho - 7;

            for (let i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2) pos = 9;
            }

            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

            if (resultado != digitos.charAt(1)) return false;
                
            return true;
        },
        validarData(inputData) {
            let valor = inputData;
            
            switch (valor.length) {
                case 1:
                    if(!isNaN(parseFloat(valor)) && isFinite(valor)) {
                        if (valor[0] >= 4) {
                            this.$toasted.global.defaultInfo({ msg : 'Dia do mês inválido > 31 dias'});
                            VueScrollTo.scrollTo('#cliente-nascimento');
                            document.getElementById("cliente-nascimento").focus()
                            valor = '';
                        }
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor apenas insira somente números na data de nascimento'});
                        VueScrollTo.scrollTo('#cliente-nascimento');
                        document.getElementById("cliente-nascimento").focus()
                        valor = '';
                    }
                    break;
                case 2:
                    if(!isNaN(parseFloat(valor[1])) && isFinite(valor[1])) {
                        if (valor[0] == 3 && valor[1] >= 2) {
                            this.$toasted.global.defaultInfo({ msg : 'Dia do mês inválido > 31 dias'});
                            VueScrollTo.scrollTo('#cliente-nascimento');
                            document.getElementById("cliente-nascimento").focus()
                            valor = `${valor[0]}`;
                        }
                        if (valor[0] == 0 && valor[1] == 0) {
                            this.$toasted.global.defaultInfo({ msg : 'Dia do mês inválido < 1 dia'});
                            VueScrollTo.scrollTo('#cliente-nascimento');
                            document.getElementById("cliente-nascimento").focus()
                            valor = `${valor[0]}`;
                        }
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor apenas insira somente números na data de nascimento'});
                        VueScrollTo.scrollTo('#cliente-nascimento');
                        document.getElementById("cliente-nascimento").focus()
                        valor = `${valor[0]}`;
                    }
                    break;
                case 3:
                    if (valor[2] !== '/') {
                        if(!isNaN(parseFloat(valor[2])) && isFinite(valor[2])) {
                            if (valor[2] >= 2) {
                                this.$toasted.global.defaultInfo({ msg : 'Mês inválido > 12 meses'});
                                VueScrollTo.scrollTo('#cliente-nascimento');
                                document.getElementById("cliente-nascimento").focus()
                                valor = `${valor[0]}${valor[1]}/`;
                            } else valor = `${valor[0]}${valor[1]}/${valor[2]}`;
                        } else {
                            this.$toasted.global.defaultInfo({ msg : 'Por favor apenas insira somente números na data de nascimento'});
                            VueScrollTo.scrollTo('#cliente-nascimento');
                            document.getElementById("cliente-nascimento").focus()
                            valor = `${valor[0]}${valor[1]}/`;
                        }
                    }
                    break;
                case 4:
                    if(!isNaN(parseFloat(valor[3])) && isFinite(valor[3])) {
                            if (valor[3] >= 2) {
                                this.$toasted.global.defaultInfo({ msg : 'Mês inválido > 12 meses'});
                                VueScrollTo.scrollTo('#cliente-nascimento');
                                document.getElementById("cliente-nascimento").focus()
                                valor = `${valor[0]}${valor[1]}/`;
                            } else valor = `${valor[0]}${valor[1]}/${valor[3]}`;
                        } else {
                            this.$toasted.global.defaultInfo({ msg : 'Por favor apenas insira somente números na data de nascimento'});
                            VueScrollTo.scrollTo('#cliente-nascimento');
                            document.getElementById("cliente-nascimento").focus()
                            valor = `${valor[0]}${valor[1]}/`;
                        }
                    break;
                case 5:
                    if(!isNaN(parseFloat(valor[4])) && isFinite(valor[4])) {
                        if (valor[3] == 1 && valor[4] >= 3) {
                            this.$toasted.global.defaultInfo({ msg : 'Mês inválido > 12 meses'});
                            VueScrollTo.scrollTo('#cliente-nascimento');
                            document.getElementById("cliente-nascimento").focus()
                            valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}`;
                        }
                        if (valor[3] == 0 && valor[4] == 0) {
                            this.$toasted.global.defaultInfo({ msg : 'Dia do mês inválido < 1 mês'});
                            VueScrollTo.scrollTo('#cliente-nascimento');
                            document.getElementById("cliente-nascimento").focus()
                            valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}`;
                        }
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor apenas insira somente números na data de nascimento'});
                        VueScrollTo.scrollTo('#cliente-nascimento');
                        document.getElementById("cliente-nascimento").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}`;
                    }
                    break;
                 case 6:
                    if (valor[5] !== '/') {
                        if(!isNaN(parseFloat(valor[5])) && isFinite(valor[5])) {
                            if (valor[5] <= 0 || valor[5] >= 3) {
                                this.$toasted.global.defaultInfo({ msg : 'Ano inválido'});
                                VueScrollTo.scrollTo('#cliente-nascimento');
                                document.getElementById("cliente-nascimento").focus()
                                valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}/`;
                            } else valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}/${valor[5]}`;
                        } else {
                            this.$toasted.global.defaultInfo({ msg : 'Por favor apenas insira somente números na data de nascimento'});
                            VueScrollTo.scrollTo('#cliente-nascimento');
                            document.getElementById("cliente-nascimento").focus()
                            valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}/`;
                        }
                    }
                    break;
                case 7:
                    if(!isNaN(parseFloat(valor[6])) && isFinite(valor[6])) {
                        if (valor[6] <= 0 || valor[6] >= 3) {
                            this.$toasted.global.defaultInfo({ msg : 'Ano inválido'});
                            VueScrollTo.scrollTo('#cliente-nascimento');
                            document.getElementById("cliente-nascimento").focus()
                            valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}`;
                        } else valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor apenas insira somente números na data de nascimento'});
                        VueScrollTo.scrollTo('#cliente-nascimento');
                        document.getElementById("cliente-nascimento").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}`;
                    }
                    break;
                case 8:
                    if(!isNaN(parseFloat(valor[7])) && isFinite(valor[7])) {
                        if (valor[6] == 1) {
                            if (!(valor[7] == 8 || valor[7] == 9)) {
                                 this.$toasted.global.defaultInfo({ msg : 'Ano inválido'});
                                 VueScrollTo.scrollTo('#cliente-nascimento');
                                document.getElementById("cliente-nascimento").focus()
                                valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}`;
                            } else valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}`;
                        }
                        if (valor[6] == 2) {
                            if (!(valor[7] == 0)) {
                                 this.$toasted.global.defaultInfo({ msg : 'Ano inválido'});
                                VueScrollTo.scrollTo('#cliente-nascimento');
                                document.getElementById("cliente-nascimento").focus()
                                valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}`;
                            } else valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}`;
                        }
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor apenas insira somente números na data de nascimento'});
                        VueScrollTo.scrollTo('#cliente-nascimento');
                        document.getElementById("cliente-nascimento").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}`;
                    }
                    break;
                case 9:
                    if(!isNaN(parseFloat(valor[8])) && isFinite(valor[8])) {
                        if (valor[6] == 2 && valor[7] == 0) {
                            if (valor[8] >= 2) { //bloqueio nascimentos após 2020
                                 this.$toasted.global.defaultInfo({ msg : 'Ano inválido'});
                                 VueScrollTo.scrollTo('#cliente-nascimento');
                                document.getElementById("cliente-nascimento").focus()
                                valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}`;
                            } else valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}`;
                        } else valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor apenas insira somente números na data de nascimento'});
                        VueScrollTo.scrollTo('#cliente-nascimento');
                        document.getElementById("cliente-nascimento").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}`;
                    }
                    break;
                case 10:
                    if(!isNaN(parseFloat(valor[9])) && isFinite(valor[9])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}`;
                        this.validaData = true;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor apenas insira somente números na data de nascimento'});
                        VueScrollTo.scrollTo('#cliente-nascimento');
                        document.getElementById("cliente-nascimento").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}`;
                        this.validaData = false;
                    }
                    break;
                case 11:
                    this.$toasted.global.defaultInfo({ msg : 'Por favor apenas insira uma data de nascimento válida'});
                    VueScrollTo.scrollTo('#cliente-nascimento');
                    document.getElementById("cliente-nascimento").focus()
                    valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}`;
                    break;
            }
            this.dataId = valor;
            document.getElementById('cliente-nascimento').value=(this.dataId);
        },
        converteData(inputData) {
            let SoNumero = inputData.replace(/\D/g, '');
            return `${SoNumero[4]}${SoNumero[5]}${SoNumero[6]}${SoNumero[7]}-${SoNumero[2]}${SoNumero[3]}-${SoNumero[0]}${SoNumero[1]}`;
        },
        validarCEP(inputCEP) {
            //Nova variável "cep" somente com dígitos.
            let cep = inputCEP.replace(/\D/g, '');

            //Verifica se campo cep possui valor informado.
            if (cep != "") {
                //Expressão regular para validar o CEP.

                if((!isNaN(parseFloat(cep)) && isFinite(cep)) && (cep.length >= 5) && (cep.length <= 12)) {       //Obriga entrada ser apenas de números
                    //Valida o formato do CEP.
                    axios.get("https://viacep.com.br/ws/"+ cep +"/json/")
                        .then((dados) => {
                            if (!("erro" in dados)) {
                                this.cliente.endereco = dados.data.logradouro;
                                document.getElementById('cliente-endereco').value=(this.cliente.endereco);
                                this.cliente.bairro = dados.data.bairro;
                                document.getElementById('cliente-bairro').value=(this.cliente.bairro);
                                this.cliente.cidade = dados.data.localidade;
                                document.getElementById('cliente-cidade').value=(this.cliente.cidade);
                                this.cliente.estado = dados.data.uf;
                                document.getElementById('cliente-estado').value=(this.cliente.estado);
                            } else this.$toasted.global.defaultError({ msg : "Erro ao consultar CEP" });
                        })
                } //end if.
                else {
                    //cep é inválido.
                    this.validaCEP = false;
                    return
                }
            } //end if.
            else {
                //cep sem valor, limpa formulário.
                this.validaCEP = false;
                return
            }
            this.validaCEP = true;
        },
        validarTelefone(inputData) {
            let valor = inputData;
            
            switch (valor.length) {
                case 1:
                    if(!isNaN(parseFloat(valor[0])) && isFinite(valor[0])) {
                        valor = `(${valor[0]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no telefone!'});
                        VueScrollTo.scrollTo('#cliente-telefone');
                        document.getElementById("cliente-telefone").focus()
                        valor = ``;
                    }
                    this.validaTelefone = false;
                    break;     
                case 3:
                    if(!isNaN(parseFloat(valor[2])) && isFinite(valor[2])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]})`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no telefone!'});
                        VueScrollTo.scrollTo('#cliente-telefone');
                        document.getElementById("cliente-telefone").focus()
                        valor = `${valor[0]}${valor[1]}`;
                    }
                    this.validaTelefone = false;
                    break;
                case 5:
                    if(!isNaN(parseFloat(valor[4])) && isFinite(valor[4])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]} ${valor[4]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no telefone!'});
                        VueScrollTo.scrollTo('#cliente-telefone');
                        document.getElementById("cliente-telefone").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}`;
                    }
                    this.validaTelefone = false;
                    break;
                case 7:
                    if(!isNaN(parseFloat(valor[6])) && isFinite(valor[6])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no telefone!'});
                        VueScrollTo.scrollTo('#cliente-telefone');
                        document.getElementById("cliente-telefone").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}`;
                    }
                    this.validaTelefone = false;
                    break;
                case 8:
                    if(!isNaN(parseFloat(valor[7])) && isFinite(valor[7])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no telefone!'});
                        VueScrollTo.scrollTo('#cliente-telefone');
                        document.getElementById("cliente-telefone").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}`;
                    }
                    this.validaTelefone = false;
                    break;
                case 9:
                    if(!isNaN(parseFloat(valor[8])) && isFinite(valor[8])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no telefone!'});
                        VueScrollTo.scrollTo('#cliente-telefone');
                        document.getElementById("cliente-telefone").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}`;
                    }
                    this.validaTelefone = false;
                    break;
                case 10:
                    if(!isNaN(parseFloat(valor[9])) && isFinite(valor[9])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}-${valor[9]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no telefone!'});
                        VueScrollTo.scrollTo('#cliente-telefone');
                        document.getElementById("cliente-telefone").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}`;
                    }
                    this.validaTelefone = false;
                    break;
                case 12:
                    if(!isNaN(parseFloat(valor[11])) && isFinite(valor[11])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no telefone!'});
                        VueScrollTo.scrollTo('#cliente-telefone');
                        document.getElementById("cliente-telefone").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}`;
                    }
                    this.validaTelefone = false;
                    break;
                case 13:
                    if(!isNaN(parseFloat(valor[12])) && isFinite(valor[12])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}${valor[12]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no telefone!'});
                        VueScrollTo.scrollTo('#cliente-telefone');
                        document.getElementById("cliente-telefone").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}`;
                    }
                    this.validaTelefone = false;
                    break;
                case 14:
                    if(!isNaN(parseFloat(valor[13])) && isFinite(valor[13])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}${valor[12]}${valor[13]}`;
                        this.validaTelefone = true;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no telefone!'});
                        VueScrollTo.scrollTo('#cliente-telefone');
                        document.getElementById("cliente-telefone").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}${valor[12]}`;
                        this.validaTelefone = false;
                    }
                    break;
                case 15:
                    if(!isNaN(parseFloat(valor[14])) && isFinite(valor[14])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[10]}${valor[9]}${valor[11]}${valor[12]}${valor[13]}${valor[14]}`;
                        this.validaTelefone = true;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no telefone!'});
                        VueScrollTo.scrollTo('#cliente-telefone');
                        document.getElementById("cliente-telefone").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}${valor[12]}${valor[13]}`;
                        this.validaTelefone = false;
                    }
                    break;
                case 16:
                    valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}${valor[12]}${valor[13]}${valor[14]}`;
                    this.$toasted.global.defaultInfo({ msg : 'Quantidade de números excedida. Ex: (11) 11111-1111'});
                    VueScrollTo.scrollTo('#cliente-telefone');
                    document.getElementById("cliente-telefone").focus()
                    this.validaTelefone = false;
                    break;  
            }
                    this.cliente.telefone = valor;
                    document.getElementById('cliente-telefone').value=(this.cliente.telefone);
        },
        validarCelular(inputData) {
            let valor = inputData;
            
            switch (valor.length) {
                case 1:
                    if(!isNaN(parseFloat(valor[0])) && isFinite(valor[0])) {
                        valor = `(${valor[0]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no celular!'});
                        VueScrollTo.scrollTo('#cliente-celular');
                        document.getElementById("cliente-celular").focus()
                        valor = ``;
                    }
                    this.validaCelular = false;
                    break;     
                case 3:
                    if(!isNaN(parseFloat(valor[2])) && isFinite(valor[2])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]})`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no celular!'});
                        VueScrollTo.scrollTo('#cliente-celular');
                        document.getElementById("cliente-celular").focus()
                        valor = `${valor[0]}${valor[1]}`;
                    }
                    this.validaCelular = false;
                    break;
                case 5:
                    if(!isNaN(parseFloat(valor[4])) && isFinite(valor[4])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]} ${valor[4]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no celular!'});
                        VueScrollTo.scrollTo('#cliente-celular');
                        document.getElementById("cliente-celular").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}`;
                    }
                    this.validaCelular = false;
                    break;
                case 7:
                    if(!isNaN(parseFloat(valor[6])) && isFinite(valor[6])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no celular!'});
                        VueScrollTo.scrollTo('#cliente-celular');
                        document.getElementById("cliente-celular").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}`;
                    }
                    this.validaCelular = false;
                    break;
                case 8:
                    if(!isNaN(parseFloat(valor[7])) && isFinite(valor[7])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no celular!'});
                        VueScrollTo.scrollTo('#cliente-celular');
                        document.getElementById("cliente-celular").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}`;
                    }
                    this.validaCelular = false;
                    break;
                case 9:
                    if(!isNaN(parseFloat(valor[8])) && isFinite(valor[8])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no celular!'});
                        VueScrollTo.scrollTo('#cliente-celular');
                        document.getElementById("cliente-celular").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}`;
                    }
                    this.validaCelular = false;
                    break;
                case 10:
                    if(!isNaN(parseFloat(valor[9])) && isFinite(valor[9])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}-${valor[9]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no celular!'});
                        VueScrollTo.scrollTo('#cliente-celular');
                        document.getElementById("cliente-celular").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}`;
                    }
                    this.validaCelular = false;
                    break;
                case 12:
                    if(!isNaN(parseFloat(valor[11])) && isFinite(valor[11])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no celular!'});
                        VueScrollTo.scrollTo('#cliente-celular');
                        document.getElementById("cliente-celular").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}`;
                    }
                    this.validaCelular = false;
                    break;
                case 13:
                    if(!isNaN(parseFloat(valor[12])) && isFinite(valor[12])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}${valor[12]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no celular!'});
                        VueScrollTo.scrollTo('#cliente-celular');
                        document.getElementById("cliente-celular").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}`;
                    }
                    this.validaCelular = false;
                    break;
                case 14:
                    if(!isNaN(parseFloat(valor[13])) && isFinite(valor[13])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}${valor[12]}${valor[13]}`;
                        this.validaCelular = true;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no celular!'});
                        VueScrollTo.scrollTo('#cliente-celular');
                        document.getElementById("cliente-celular").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}${valor[12]}`;
                        this.validaCelular = false;
                    }
                    break;
                case 15:
                    if(!isNaN(parseFloat(valor[14])) && isFinite(valor[14])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[10]}${valor[9]}${valor[11]}${valor[12]}${valor[13]}${valor[14]}`;
                        this.validaCelular = true;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no celular!'});
                        VueScrollTo.scrollTo('#cliente-celular');
                        document.getElementById("cliente-celular").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}${valor[12]}${valor[13]}`;
                        this.validaCelular = false;
                    }
                    break;
                case 16:
                    valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}${valor[12]}${valor[13]}${valor[14]}`;
                    this.$toasted.global.defaultInfo({ msg : 'Quantidade de números excedida. Ex: (11) 11111-1111'});
                    VueScrollTo.scrollTo('#cliente-celular');
                    document.getElementById("cliente-celular").focus()
                    this.validaCelular = false;
                    break;  
            }
            this.cliente.celular = valor;
            document.getElementById('cliente-celular').value=(this.cliente.celular);
        },
        validarValidade(inputData) {
            let valor = inputData;
            
            switch (valor.length) {
                case 1:
                    if(!isNaN(parseFloat(valor[0])) && isFinite(valor[0])) {
                        if (valor[0] >= 2) {
                            this.$toasted.global.defaultInfo({ msg : 'Validade: Mês inválido > 12 meses'});
                            VueScrollTo.scrollTo('#cliente-valid-mes');
                            document.getElementById("cliente-valid-mes").focus()
                            valor = ``;
                        } else valor = `${valor[0]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números na validade do cartão de crédito!'});
                        VueScrollTo.scrollTo('#cliente-valid-mes');
                        document.getElementById("cliente-valid-mes").focus()
                        valor = ``;
                    }
                    this.validaValidade = false;
                    break;
                case 2:
                    if(!isNaN(parseFloat(valor[1])) && isFinite(valor[1])) {
                        if ( valor[0] == 1 && valor[1] >= 3) {
                            valor = `${valor[0]}`;
                            this.$toasted.global.defaultInfo({ msg : 'Validade: Mês inválido > 12 meses'});
                            VueScrollTo.scrollTo('#cliente-valid-mes');
                            document.getElementById("cliente-valid-mes").focus()
                        } else {
                            valor = `${valor[0]}${valor[1]}/`;
                        }
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números na validade do cartão de crédito!'});
                        VueScrollTo.scrollTo('#cliente-valid-mes');
                        document.getElementById("cliente-valid-mes").focus()
                        valor = `${valor[0]}`;
                    }
                    this.validaValidade = false;
                    break;
                case 4:
                    if(!isNaN(parseFloat(valor[3])) && isFinite(valor[3])) {
                        if (valor[3] <= 1) {
                            this.$toasted.global.defaultInfo({ msg : 'Validade: Ano inválido < 2020'});
                            VueScrollTo.scrollTo('#cliente-valid-mes');
                            document.getElementById("cliente-valid-mes").focus()
                            valor = `${valor[0]}${valor[1]}${valor[2]}`;
                        } else {
                            valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}`;
                        }
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números na validade do cartão de crédito!'});
                        VueScrollTo.scrollTo('#cliente-valid-mes');
                        document.getElementById("cliente-valid-mes").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}`;
                    }
                    this.validaValidade = false;
                    break;
                case 5:
                    if(!isNaN(parseFloat(valor[4])) && isFinite(valor[4])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}`;
                        this.validaValidade = true;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números na validade do cartão de crédito!'});
                        VueScrollTo.scrollTo('#cliente-valid-mes');
                        document.getElementById("cliente-valid-mes").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}`;
                        this.validaValidade = false;
                    }
                    break;
                case 6:
                    this.$toasted.global.defaultInfo({ msg : 'Quantidade de números excedida. Ex: MM/AA'});
                    VueScrollTo.scrollTo('#cliente-valid-mes');
                    document.getElementById("cliente-valid-mes").focus()
                    valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}`;
                    this.validaValidade = true;
                    break;
            }
            this.cliente.valid_mes = valor;
            document.getElementById('cliente-valid-mes').value=(this.cliente.valid_mes);
            if(this.validaValidade) {
                this.cliente.valid_mes = `${valor[0]}${valor[1]}`;
                this.cliente.valid_ano = `${valor[3]}${valor[4]}`;
            }
        },
        validarEmail(email) {
            let emailPattern =  /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
            return emailPattern.test(email); 
        },
        validarHionAcredita(acredita) {
            if ((acredita.length >= 8) && (acredita.length <= 12)) {
                return true;
            } else {
                return false;
            }
        },
        validarCartao(nr) {

            if(nr.length > 16 || nr.length <= 13 || nr[0]==0) {
                this.$toasted.global.defaultInfo({ msg : 'Por favor informe um número do cartão de crédito válido!' })
                VueScrollTo.scrollTo('#cliente-cartao');
                document.getElementById("cliente-cartao").focus()
                return false;
            }

            let cartoes = {
                    Visa: /^4[0-9]{12}(?:[0-9]{3})/,
                    Mastercard: /^5[1-5][0-9]{14}/,
                    Amex: /^3[47][0-9]{13}/,
                    DinersClub: /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
                    Discover: /^6(?:011|5[0-9]{2})[0-9]{12}/,
                    JCB: /^(?:2131|1800|35\d{3})\d{11}/
            };
            for (let cartao in cartoes) if (nr.match(cartoes[cartao])) {
                switch (cartao) {
                    case 'Visa':
                        this.cliente.bandeira = 'visa';
                        this.bandeiraCartao = 'visa';
                        document.getElementById('cliente-bandeira').value=(this.bandeiraCartao);
                        break;
                    case 'Mastercard':
                        this.cliente.bandeira = 'master';
                        this.bandeiraCartao = 'master';
                        document.getElementById('cliente-bandeira').value=(this.bandeiraCartao);
                        break;
                    default:
                        this.$toasted.global.defaultInfo({ msg : 'Operadora do cartão de crédito incompatível! Por favor utilize outro cartão de crédito!' });
                        VueScrollTo.scrollTo('#cliente-cartao');
                        document.getElementById("cliente-cartao").focus()
                        return;
                }
                return cartao;
            }
            this.$toasted.global.defaultInfo({ msg : 'Por favor informe um número do cartão de crédito válido!' })
            VueScrollTo.scrollTo('#cliente-cartao');
            document.getElementById("cliente-cartao").focus()
            return false;
        }
    },
    mounted() {
        this.reset()
    }
}
</script>

<style>
    .cadastrocliente {
        position: relative;
        width: 100%;
        height: 100%;
    }
</style>